import React, { Component, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import ChangePassword from "../../Pages/Login/ChangePassword";
import { BaseUrl } from "../../Helper/BaseUrl";
import HeaderLogo from "./HeaderLogo";
import { LanguageDataDDL } from "../CommonDDL/LanguageDataDDL";
import { CommonDashboardBtn } from "../../Pages/CommonDashboardBtn/CommonDashboardBtn";

export default function Header(props) {

    const { setWardValue,
        setWardLabel,
        HideYearMonthDDL,
        Language,
        setLanguage,
        DashType,
        setDashType
    } = props


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ChangePasswordPopUp, setChangePasswordPopUp] = useState()

    const handleChangePassword = () => {
        setChangePasswordPopUp(true)
    }

    const handleOnCloseClick = () => {
        setChangePasswordPopUp(false)
    }

    const navigate = useNavigate()


    useEffect(() => {
        if (setWardValue !== undefined) {
            setWardValue(WardName.ID)
        }
        if (setWardLabel !== undefined) {
            setWardLabel(WardName.Label)
        }
    }, [WardName.ID])

    const logOutClick = () => {
        navigate("/")
    }

    const toggle = () => {
        const sidebar = document.getElementById('SidebarToggle')
        sidebar.classList.toggle('active')
        sidebar.classList.toggle('sidebaractive')
    }

    return (
        <>
            <div className="pb-1 header " >
                <header className="navbar pcoded-header navbar-expand-lg navbar-expand-md navbar-light header-dark navbar_new">
                    <HeaderLogo />
                    <div className="m-header">
                        <span onClick={toggle} >
                            <i className="fa-solid fa-bars ham-burger mt-lg-3 ml-lg-2"></i>
                        </span>
                        <a className="mobile-menu toggler_md_icon" id="mobile-collapse"
                        >
                            {
                                BaseUrl == "https://apiamravatimc.cdat.work" ?
                                    <img src="../assets/img/amravati.png" alt="" className="ps-3 pc_none mob_logo" style={{ width: '60px' }} />
                                    :
                                    <img src="../assets/img/PCMC_Logo-01.png" alt="" className="ps-3 pc_none mob_logo" style={{ width: '60px' }} />

                            }
                        </a>

                    </div>
                    <div className="navbar-collapse py-2">
                        <div className="navbar-nav mr-auto col-7  ">
                            <h4 className="mob_head head_md pt-2 ps-5 text-dark" >उद्यान व वृक्षसंवर्धन कामांचे सनियंत्रण संगणक प्रणाली<br className="d-lg-none d-md-none" />
                                <span className="ps-3 mob_head_span tab_head_span" style={{ color: "#01836D" }}>वेब व मोबाईल आधारित</span>
                            </h4>
                            {/* <h4 className="text-black py-2 text-center fw-bold ml-lg-3 dash_head dash_heading_nums2" >
                                PCMC DAKSHA
                                <br />
                                <span className="ps-2" style={{ fontSize: '14px', color: 'green' }}>   वेब व मोबाईल आधारित</span>
                            </h4> */}

                            {/* <h4 className="text-black py-2 text-center fw-bold ml-lg-3 dash_heading_nums " >
                                PCMC DAKSHA
                                <span className="ps-2" style={{ fontSize: '14px', color: 'green' }}>   वेब व मोबाईल आधारित</span>
                            </h4> */}



                        </div>

                        {/* <div className=" col-12 col-lg-8">
                            <CommonDashboardBtn
                                DashType={DashType}
                                setDashType={setDashType}
                            />
                        </div> */}


                        <div className="col-12 col-lg-2 text-center ps-3  mob_year_month_ddl mt-lg-2 ">
                            {
                                HideYearMonthDDL == 'Dashboard' &&
                                <>
                                  
                                </>
                            }
                            <LanguageDataDDL
                                Language={Language}
                                setLanguage={setLanguage}
                            />

                        </div>
                        <div className="  col-lg-1 logout-container">
                            <button className="btn" data-bs-toggle="dropdown" aria-expanded="false">
                                <img className="avatar_size" src="../assets/img/avatar-2.png" alt="" style={{ width: "2em" }} />
                            </button>
                            <ul className="dropdown-menu logout-dropdown " aria-labelledby="dropdownMenuButton1">
                                <li className="lineheight p-2"
                                    onClick={handleChangePassword}
                                >
                                    <a class="dropdown-item text-start" href="#">
                                        <i class="fa-solid fa-lock"></i> <b>Change Password </b>
                                    </a>
                                </li>
                                <li className="lineheight p-2"
                                    onClick={logOutClick}
                                >
                                    <a class="dropdown-item text-start text-danger" href="#">
                                        <i class="fa-solid fa-power-off "></i> <b> Log out</b>
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>
                </header>
            </div>
            {
                ChangePasswordPopUp ?
                    <ChangePassword
                        open={ChangePasswordPopUp}
                        popupHeading="Change Password"
                        handleOnCloseClick={handleOnCloseClick}
                    />
                    : <></>
            }
        </>
    )
}